import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IconModule } from "../icon/icon.module";
import { TagComponent } from "./tag.component";
import { FormsModule } from "@angular/forms";

@NgModule({
	declarations: [TagComponent],
	imports: [CommonModule, IconModule, FormsModule],
	exports: [TagComponent]
})
export class TagModule {}
